// src/pages/AnketlerPage.js
import React from "react";
import GlobalStyles from "@mui/material/GlobalStyles";

import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from "../config";
import { useNotify } from "react-admin";
import ResimUpload from "../ResimUpload";
import Editor from "@monaco-editor/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { List, useListContext } from "react-admin";
import { Box, Paper, Chip, Stack, Typography } from "@mui/material";

import { TopToolbar, CreateButton } from "react-admin";


import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


/* =========================== Dil Metinleri =========================== */
const ALLOWED = ["tr", "en", "de"];
const T = {
  tr: {
    pageTitle: "🗳️ Anket",
    listTitle: "🗳️ Anketler",
    createTitle: "🆕 Yeni Anket",
    editTitle: "✏️ Anketi Düzenle",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    savedOk: "✅ Anket kaydedildi",
edit: "Düzenle",
delete: "Sil",

    savedErr: "❌ Kayıt hatası",

    general: "Genel",
    title: "Başlık",
    desc: "Açıklama",
    image: "Kapak Görseli",
    active: "Aktif",
    draft: "Taslak",
    loginRequired: "Sadece giriş yapan cevap verebilsin",
    onePerUser: "Kullanıcı başı bir cevap",
    dates: "Yayın Tarihleri",
    startAt: "Başlangıç",
    endAt: "Bitiş",
    maxTextLen: "Metin cevap max uzunluk (varsayılan 500)",

    questions: "Sorular",
    addQuestion: "+ Soru Ekle",
    type: "Tip",
    single: "Tek seçim",
    multi: "Çoklu seçim",
    text: "Metin",
    required: "Zorunlu",
    options: "Seçenekler",
    addOption: "+ Seçenek Ekle",
    optionLabel: "Seçenek Etiketi",
    optionId: "Seçenek ID",
    remove: "Sil",
    langBlock: (code) => `(${code.toUpperCase()})`,
    questionTitle: "Soru Başlığı",
    maxSelect: "En fazla seçim (opsiyonel)",

    quickTemplates: "Hızlı Şablonlar",
    tplYesNoMaybe: "Evet / Hayır / Kararsızım",
    tplYesNo: "Evet / Hayır",
    tplRsvpNote: "RSVP + Not (E/H + Metin)",

    advanced: "İleri Düzey (JSON)",
    preview: "Önizleme",
    placeholderTitle: "Başlık girin…",
on: "Açık",
off: "Kapalı",
    placeholderDesc: "Kısa açıklama…",


    jsonInvalid: "JSON geçersiz. Lütfen kontrol edin.",
  },
  en: {
    pageTitle: "🗳️ Survey",
    listTitle: "🗳️ Surveys",
    createTitle: "🆕 New Survey",
    editTitle: "✏️ Edit Survey",
    save: "Save",
    saving: "Saving…",
    savedOk: "✅ Survey saved",
edit: "Edit",
delete: "Delete",


    savedErr: "❌ Save error",

    general: "General",
    title: "Title",
    desc: "Description",
    image: "Cover Image",
    active: "Active",
    draft: "Draft",
    loginRequired: "Require login to vote",
    onePerUser: "One response per user",
    dates: "Dates",
    startAt: "Start",
    endAt: "End",
    maxTextLen: "Text answer max length (default 500)",

    questions: "Questions",
    addQuestion: "+ Add Question",
    type: "Type",
    single: "Single",
    multi: "Multi",
    text: "Text",
    required: "Required",
    options: "Options",
    addOption: "+ Add Option",
    optionLabel: "Option Label",
    optionId: "Option ID",
    remove: "Remove",
    langBlock: (code) => `(${code.toUpperCase()})`,
    questionTitle: "Question Title",
    maxSelect: "Max select (optional)",

    quickTemplates: "Quick Templates",
    tplYesNoMaybe: "Yes / No / Not sure",
    tplYesNo: "Yes / No",
    tplRsvpNote: "RSVP + Note (Y/N + Text)",

    advanced: "Advanced (JSON)",
    preview: "Preview",
    placeholderTitle: "Enter title…",
on: "On",
off: "Off",

    placeholderDesc: "Short description…",

    jsonInvalid: "Invalid JSON. Please check.",
  },
  de: {
    pageTitle: "🗳️ Umfrage",
    listTitle: "🗳️ Umfragen",
    createTitle: "🆕 Neue Umfrage",
    editTitle: "✏️ Umfrage bearbeiten",
    save: "Speichern",
    saving: "Wird gespeichert…",
    savedOk: "✅ Umfrage gespeichert",
edit: "Bearbeiten",
delete: "Löschen",

    savedErr: "❌ Fehler beim Speichern",

    general: "Allgemein",
    title: "Titel",
    desc: "Beschreibung",
    image: "Titelbild",
    active: "Aktiv",
    draft: "Entwurf",
    loginRequired: "Nur eingeloggte Nutzer antworten",
    onePerUser: "Pro Nutzer eine Antwort",
    dates: "Zeitraum",
    startAt: "Start",
    endAt: "Ende",
    maxTextLen: "Max. Länge (Standard 500)",

    questions: "Fragen",
    addQuestion: "+ Frage hinzufügen",
    type: "Typ",
    single: "Einzelauswahl",
    multi: "Mehrfachauswahl",
    text: "Text",
    required: "Pflichtfeld",
    options: "Optionen",
    addOption: "+ Option hinzufügen",
    optionLabel: "Optionsbezeichnung",
    optionId: "Option-ID",
    remove: "Löschen",
    langBlock: (code) => `(${code.toUpperCase()})`,
    questionTitle: "Fragentitel",
    maxSelect: "Max. Auswahl (optional)",

    quickTemplates: "Schnellvorlagen",
    tplYesNoMaybe: "Ja / Nein / Unentschieden",
    tplYesNo: "Ja / Nein",
    tplRsvpNote: "RSVP + Notiz (J/N + Text)",

    advanced: "Erweitert (JSON)",
    preview: "Vorschau",
    placeholderTitle: "Titel eingeben…",
on: "An",
off: "Aus",

    placeholderDesc: "Kurze Beschreibung…",

    jsonInvalid: "Ungültiges JSON. Bitte prüfen.",
  },
};

function useUiTexts() {
  const [uiLang, setUiLang] = React.useState(
    () => (localStorage.getItem("app_lang") || "tr").slice(0, 2).toLowerCase()
  );
  React.useEffect(() => {
    const sync = () => {
      const l = (localStorage.getItem("app_lang") || "tr")
        .slice(0, 2)
        .toLowerCase();
      setUiLang(ALLOWED.includes(l) ? l : "tr");
    };
    window.addEventListener("app_lang_change", sync);
    window.addEventListener("storage", sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener("app_lang_change", sync);
      window.removeEventListener("storage", sync);
      window.removeEventListener("focus", sync);
    };
  }, []);
  return T[ALLOWED.includes(uiLang) ? uiLang : "tr"];
}

/* =========================== Upload URL normalize (panel→ana domain, http→https, /uploads) =========================== */
const ORIGIN =
  ORIGIN_BASE || (typeof window !== "undefined" ? window.location.origin : "");
const UP_BASE = (UPLOAD_BASE && UPLOAD_BASE.trim()) || "";

function originWithoutPanel(originStr) {
  try {
    const u = new URL(originStr);
    if (u.hostname.startsWith("panel.")) {
      u.hostname = u.hostname.replace(/^panel\./, "");
      return u.origin;
    }
    return u.origin;
  } catch {
    return originStr;
  }
}

function normalizeUploadUrl(raw) {
  if (!raw) return "";
  let u = String(raw).trim();
  u = u.replace(/^http:\/\//i, "https://"); // http→https
  if (!/^https?:\/\//i.test(u) && !u.startsWith("/")) {
    u = `/uploads/${u}`;
  }
  const strip = (p) =>
    p.replace(/^\/?(upload|uploads)\//i, "").replace(/^\/+/, "");
  try {
    const abs = new URL(u, ORIGIN);
    const filePart = strip(abs.pathname);
    const chosenOrigin = UP_BASE
      ? new URL(UP_BASE, ORIGIN).origin
      : originWithoutPanel(ORIGIN);
    const baseUrl = new URL(UP_BASE || "/uploads", chosenOrigin);
    let basePath = baseUrl.pathname.replace(/\/+$/, "");
    if (!/(\/upload(s)?)$/i.test(basePath)) basePath += "/uploads";
    return `${baseUrl.origin}${basePath}/${filePart}`;
  } catch {
    return u;
  }
}

const BANNER_COLORS = [
  ["#f59e0b", "#2563eb"], // turuncu → mavi
  ["#fb923c", "#1d4ed8"], // açık turuncu → koyu mavi
  ["#f97316", "#3b82f6"], // canlı turuncu → mavi
  ["#facc15", "#0ea5e9"], // altın → turkuaz
  ["#ec4899", "#6366f1"], // pembe → mor (premium)
];


/* =========================== UI Helpers =========================== */
const YES_NO = {
  tr: { yes: "Evet", no: "Hayır" },
  en: { yes: "Yes",  no: "No" },
  de: { yes: "Ja",   no: "Nein" },
};


const Section = ({ title, children }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: 8,
      padding: 16,
      border: "1px solid #e5e7eb",
    }}
  >
    <h3
      style={{
        marginTop: 0,
        marginBottom: 12,
        fontWeight: 800,
        color: "#0f172a",
      }}
    >
      {title}
    </h3>
    <div className="space-y-4">{children}</div>
  </div>
);

const Toggle = ({ label, checked, onChange, TT }) => (
  <label
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 14,
      padding: "6px 10px",
      borderRadius: 6,
      border: "1px solid #e5e7eb",
      background: "#fff",
    }}
  >
    <span style={{ fontWeight: 600 }}>{label}</span>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <span
        style={{
          fontSize: 12,
          color: "#475569",
          minWidth: 38,
          textAlign: "right",
        }}
      >
{checked ? TT.on : TT.off}
      </span>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ transform: "scale(1.4)", marginLeft: 4, cursor: "pointer" }}
      />
    </div>
  </label>
);

const Row = ({ label, value, onChange, placeholder, right }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: right ? "1fr auto" : "1fr",
      gap: 8,
    }}
  >
    <label className="block font-medium mb-1" style={{ marginBottom: 6 }}>
      {label}
    </label>
    <input
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full border rounded px-3 py-2"
      placeholder={placeholder || ""}
    />
    {right}
  </div>
);

const Area = ({ label, value, onChange, rows = 4, placeholder }) => (
  <div>
    <label className="block font-medium mb-1" style={{ marginBottom: 6 }}>
      {label}
    </label>
    <textarea
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="w-full border rounded px-3 py-2"
      rows={rows}
      placeholder={placeholder || ""}
    />
  </div>
);

// 🔹 Tarih + Saat seçici
const DateTimeRow = ({ label, value, onChange }) => {
  // backend UTC string saklıyor, biz date-local gösteriyoruz
  const toInputValue = (val) => {
    if (!val) return "";
    const d = new Date(val);
    if (isNaN(d)) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  const fromInputValue = (val) => {
    if (!val) return "";
    return new Date(val).toISOString(); // ISO string kaydediyoruz
  };
  return (
    <div>
      <label className="block font-medium mb-1" style={{ marginBottom: 6 }}>
        {label}
      </label>
      <input
        type="datetime-local"
        value={toInputValue(value)}
        onChange={(e) => onChange(fromInputValue(e.target.value))}
        className="w-full border rounded px-3 py-2"
      />
    </div>
  );
};








/* =========================== Kapak Görseli (normalize + cache-bust) =========================== */
const bust = (u, v) => (u ? `${u}${u.includes("?") ? "&" : "?"}v=${v}` : "");

function CoverImageRow({ label, value, onChange, ver, setVer }) {
  const previewUrl = value ? bust(value, ver) : "";
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "96px 1fr",
        gap: 12,
        alignItems: "center",
      }}
    >
      <div>
        {value ? (
          <img
            key={previewUrl}
            src={previewUrl}
            alt="cover-preview"
            style={{
              width: 88,
              height: 88,
              objectFit: "cover",
              borderRadius: 10,
              border: "1px solid #e5e7eb",
            }}
          />
        ) : (
          <div
            style={{
              width: 88,
              height: 88,
              borderRadius: 10,
              border: "1px dashed #cbd5e1",
              display: "grid",
              placeItems: "center",
              color: "#94a3b8",
              fontSize: 20,
            }}
          >
            🖼️
          </div>
        )}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8 }}>
        <div>
          <label className="block font-medium mb-1" style={{ marginBottom: 6 }}>
            {label}
          </label>
          <input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            onBlur={(e) => {
              const fixed = normalizeUploadUrl(e.target.value);
              onChange(fixed);
              setVer((n) => n + 1);
            }}
            className="w-full border rounded px-3 py-2"
            placeholder="https://..."
          />
        </div>
        <ResimUpload
          label="Yükle"
          onUpload={(url) => {
            const fixed = normalizeUploadUrl(url);
            onChange(fixed); // EtkinliklerPage gibi: normalize edip kaydet
            setVer((n) => n + 1); // cache-bust
          }}
        />
      </div>
    </div>
  );
}

/* =========================== Anket Builder =========================== */
function useAktifDiller() {
  const [aktifDiller, setAktifDiller] = React.useState(ALLOWED);
  React.useEffect(() => {
    try {
      const s = localStorage.getItem("kurum_ayarlar");
      if (s) {
        const j = JSON.parse(s);
        const arr = Array.isArray(j?.aktif_diller)
          ? j.aktif_diller.map((x) => x?.toLowerCase().slice(0, 2))
          : ALLOWED;
        const filtered = arr.filter((x) => ALLOWED.includes(x));
        setAktifDiller(filtered.length ? filtered : ALLOWED);
      } else {
        setAktifDiller(ALLOWED);
      }
    } catch {
      setAktifDiller(ALLOWED);
    }
  }, []);
  return aktifDiller;
}

function emptyMultilang(aktifDiller) {
  const obj = {};
  aktifDiller.forEach((c) => (obj[c] = ""));
  return obj;
}

const uiLang = (localStorage.getItem("app_lang") || "tr")
  .slice(0, 2)
  .toLowerCase();

// 3 dil birden görüntülensin:
const getPanelLang = () =>
  (localStorage.getItem("app_lang") || "tr")
    .slice(0, 2)
    .toLowerCase();

const sadeceDil = [getPanelLang()];



function QuestionEditor({ q, onChange, onRemove, aktifDiller, TT }) {
  const setQ = (patch) => onChange({ ...q, ...patch });

  const ensureOptions = () => {
    if (!Array.isArray(q.options)) setQ({ options: [] });
  };

  const addOption = () => {
    ensureOptions();
    const nextId = `o${(q.options?.length || 0) + 1}`;
const label = { [sadeceDil[0]]: "" };
    setQ({ options: [...(q.options || []), { id: nextId, label }] });
  };

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 12,
        marginBottom: 12,
      }}
    >
      <div
        style={{
          display: "grid",
gridTemplateColumns: "1fr",
          gap: 12,
          alignItems: "center",
        }}
      >
       
        <div>
          <label className="block font-medium mb-1" style={{ marginBottom: 6 }}>
            {TT.type}
          </label>
          <select
            className="w-full border rounded px-3 py-2"
            value={q.type}
            onChange={(e) => setQ({ type: e.target.value })}
          >
            <option value="single">{TT.single}</option>
            <option value="multi">{TT.multi}</option>
            <option value="text">{TT.text}</option>
          </select>
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
        


          <button
            type="button"
            onClick={onRemove}
            style={{
              padding: "6px 10px",
              borderRadius: 6,
              border: "1px solid #ef4444",
              color: "#ef4444",
            }}
          >
            {TT.remove}
          </button>
        </div>
      </div>

      {/* Çok dilli başlık alanları */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 8,
          marginTop: 10,
        }}
      >
{sadeceDil.map((code) => (
          <Row
            key={code}
label={TT.questionTitle}
            value={q.title?.[code] || ""}
            onChange={(v) => setQ({ title: { ...(q.title || {}), [code]: v } })}
            placeholder=""
          />
        ))}
      </div>

      {/* Metin türü için max length */}
      {q.type === "text" && (
        <div style={{ marginTop: 10, maxWidth: 260 }}>
          <Row
            label={TT.maxTextLen}
            value={q.maxLength || ""}
            onChange={(v) => setQ({ maxLength: v.replace(/\D/g, "") })}
            placeholder="500"
          />
        </div>
      )}

      {/* Single/Multi için seçenekler */}
      {(q.type === "single" || q.type === "multi") && (
        <div style={{ marginTop: 12 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>{TT.options}</div>
          {(q.options || []).map((opt, idx) => (
            <div
              key={idx}
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                padding: 10,
                marginBottom: 8,
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 200px auto",
                  gap: 10,
                  alignItems: "center",
                }}
              >
               
                
                <button
                  type="button"
                  onClick={() => {
                    const options = [...(q.options || [])];
                    options.splice(idx, 1);
                    setQ({ options });
                  }}
                  style={{
                    padding: "6px 10px",
                    borderRadius: 6,
                    border: "1px solid #ef4444",
                    color: "#ef4444",
                    height: 40,
                  }}
                >
                  {TT.remove}
                </button>
              </div>

              {/* Çok dilli seçenek etiketleri */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: 8,
                  marginTop: 8,
                }}
              >
{sadeceDil.map((code) => (
                  <Row
                    key={code}
label={TT.optionLabel}
                    value={opt.label?.[code] || ""}
                    onChange={(v) => {
                      const options = [...(q.options || [])];
                      const label = { ...(opt.label || {}), [code]: v };
                      options[idx] = { ...opt, label };
                      setQ({ options });
                    }}
                    placeholder=""
                  />
                ))}
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={addOption}
            className="px-4 py-2 rounded text-white"
            style={{ backgroundColor: "#16a34a" }}
          >
            {TT.addOption}
          </button>

          {q.type === "multi" && (
            <div style={{ marginTop: 10, maxWidth: 260 }}>
              <Row
                label={TT.maxSelect}
                value={q.maxSelect || ""}
                onChange={(v) => setQ({ maxSelect: v.replace(/\D/g, "") })}
                placeholder=""
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* =========================== Önizleme =========================== */
function SurveyPreview({ survey, aktifDiller, TT }) {
  const preferredLang = (localStorage.getItem("app_lang") || "tr")
    .slice(0, 2)
    .toLowerCase();
const pickLang = (obj) => {
  if (!obj) return "";
  if (obj[preferredLang]) return obj[preferredLang];
  return Object.values(obj)[0] || "";
};


 const title =
  survey[`baslik_${preferredLang}`] ||
  survey.baslik_tr ||
  survey.baslik_en ||
  survey.baslik_de ||
  "";

const desc =
  survey[`aciklama_${preferredLang}`] ||
  survey.aciklama_tr ||
  survey.aciklama_en ||
  survey.aciklama_de ||
  "";


  return (
    <div
      style={{ border: "1px dashed #cbd5e1", borderRadius: 8, padding: 12 }}
    >
      {survey.resim && (
        <div style={{ marginBottom: 10 }}>
          <img
            alt="cover"
            src={survey.resim}
            style={{
              width: "100%",
              maxHeight: 220,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
        </div>
      )}
      <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>
        {title || TT.placeholderTitle}
      </div>
      <div style={{ color: "#475569", marginBottom: 12 }}>
        {desc || TT.placeholderDesc}
      </div>

      <div className="space-y-3">
        {(survey.questions || []).map((q) => {
          const qTitle = pickLang(q.title);
          if (q.type === "text") {
            return (
              <div key={q.id} style={{ marginBottom: 10 }}>
                <div style={{ fontWeight: 600, marginBottom: 6 }}>{qTitle}</div>
                <textarea
                  className="w-full border rounded px-3 py-2"
                  placeholder=""
                  disabled
                />
              </div>
            );
          }
          if (q.type === "single" || q.type === "multi") {
            return (
              <div key={q.id} style={{ marginBottom: 10 }}>
                <div style={{ fontWeight: 600, marginBottom: 6 }}>{qTitle}</div>
                <div className="space-y-1">
                  {(q.options || []).map((opt) => (
                    <label
                      key={opt.id}
                      style={{ display: "flex", gap: 8, alignItems: "center" }}
                    >
                      <input
                        type={q.type === "single" ? "radio" : "checkbox"}
                        disabled
                      />
                      <span>{pickLang(opt.label)}</span>
                    </label>
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}

/* =========================== Paylaşılan Form =========================== */
function SharedAnketForm({ mode = "create" }) {
  const TT = useUiTexts();
  const notify = useNotify();
  const aktifDiller = useAktifDiller();

  // Eğer edit modundaysak, URL'den id al (opsiyonel)
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const editingId =
    mode === "edit" ? (params?.id ? Number(params.id) : null) : null;

  const [loading, setLoading] = React.useState(mode === "edit");
  const [saving, setSaving] = React.useState(false);

  const [survey, setSurvey] = React.useState(() => ({
    // multilang başlık/açıklama
    baslik_tr: "",
    baslik_en: "",
    baslik_de: "",
    aciklama_tr: "",
    aciklama_en: "",
    aciklama_de: "",
    resim: "", // <-- EtkinliklerPage ile aynı isim

    aktif: true,
    taslak: false,
    login_required: true,
    one_per_user: true,

    start_at: "",
    end_at: "",
    max_text_length: 500,

    questions: [],
  }));

  // 🔹 Kapak önizleme için cache-bust versiyonu
  const [ver, setVer] = React.useState(0);

  // Edit durumu: kaydı yükle (opsiyonel; RA list/edit routingine göre)
  React.useEffect(() => {
    if (mode !== "edit" || !editingId) return;
    const token = localStorage.getItem("token");
    const load = async () => {
      try {
        const res = await fetch(`${API_BASE}/anketler/${editingId}`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.ok) {
          const j = await res.json();
          // normalize:
          const img =
            j.resim || j.image_url || j.kapak || "";
          setSurvey({
            baslik_tr: j.baslik_tr || "",
            baslik_en: j.baslik_en || "",
            baslik_de: j.baslik_de || "",
            aciklama_tr: j.aciklama_tr || "",
            aciklama_en: j.aciklama_en || "",
            aciklama_de: j.aciklama_de || "",
            resim: normalizeUploadUrl(img),
            aktif: !!j.aktif,
            taslak: !!j.taslak,
            login_required: j.login_required ?? true,
            one_per_user: j.one_per_user ?? true,
            start_at: j.start_at || "",
            end_at: j.end_at || "",
            max_text_length: j.max_text_length || 500,
            questions: Array.isArray(j.questions) ? j.questions : [],
          });
          setVer((n) => n + 1);
        }
      } catch {}
      setLoading(false);
    };
    load();
  }, [mode, editingId]);

  const set = (patch) => setSurvey((prev) => ({ ...prev, ...patch }));

  // Soru ekle
  const addQuestion = () => {
    const idx = (survey.questions || []).length + 1;
    const q = {
      id: `q${idx}`,
      type: "single",
title: { [sadeceDil[0]]: "" },
      required: true,
      options: [
        {
          id: "o1",
label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.yes || "Yes" },
      },
        {
  id: "o2",
  label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.no || "No" },

}

      ],
    };
    set({ questions: [...(survey.questions || []), q] });
  };

  // Hızlı şablonlar
  const applyTemplate = (key) => {
if (key === "yes-no-maybe") {
  set({
    questions: [
      {
        id: "q1",
        type: "single",

       title: {
  [sadeceDil[0]]:
    sadeceDil[0] === "tr"
      ? "Gelecek misin?"
      : sadeceDil[0] === "en"
      ? "Will you come?"
      : "Wirst du kommen?",
},

        required: true,
      options: [
  {
    id: "o1",
    label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.yes || "Yes" },
  },
  {
    id: "o2",
    label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.no || "No" },
  },
  {
    id: "o3",
    label: {
      [sadeceDil[0]]:
        sadeceDil[0] === "tr"
          ? "Kararsızım"
          : sadeceDil[0] === "en"
          ? "Not sure"
          : "Unentschieden",
    },
  },
],


      },
    ],
  });
}
else if (key === "yes-no") {
  set({
    questions: [
      {
        id: "q1",
        type: "single",
       title: {
  [sadeceDil[0]]:
    sadeceDil[0] === "tr"
      ? "Gelecek misin?"
      : sadeceDil[0] === "en"
      ? "Will you come?"
      : "Wirst du kommen?",
},

        required: true,

      options: [
  {
    id: "o1",
    label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.yes || "Yes" },
  },
  {
    id: "o2",
    label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.no || "No" },
  },
],


      },
    ],

  });
}
else if (key === "rsvp-note") {
  set({
    questions: [
      {
        id: "q1",
        type: "single",

       title: {
  [sadeceDil[0]]:
    sadeceDil[0] === "tr"
      ? "Gelecek misin?"
      : sadeceDil[0] === "en"
      ? "Will you come?"
      : "Wirst du kommen?",
},

        required: true,

       options: [
  {
    id: "o1",
    label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.yes || "Yes" },
  },
  {
    id: "o2",
    label: { [sadeceDil[0]]: YES_NO[sadeceDil[0]]?.no || "No" },
  },
],




      },
      {
        id: "q2",
        type: "text",
        title: {
  [sadeceDil[0]]:
    sadeceDil[0] === "tr"
      ? "Eklemek istediğin not var mı?"
      : sadeceDil[0] === "en"
      ? "Would you like to add a note?"
      : "Möchtest du eine Notiz hinzufügen?",
},
},

    ],
  });
}  // ✔ BU SON KAPANAN PARANTEZ DOĞRU
};


  const trySave = async (e) => {
    e.preventDefault();
    setSaving(true);
    const token = localStorage.getItem("token");

    try {
      const payload = { ...survey };

      // resim URL normalize + uyumluluk alanları
      const fixedImage = normalizeUploadUrl(payload.resim || "");
      payload.resim = fixedImage;
      payload.image_url = fixedImage; // uyumluluk
      payload.kapak = fixedImage; // uyumluluk

      // normalize tarih alanları (empty => null)
      payload.start_at = payload.start_at?.trim() ? payload.start_at : null;
      payload.end_at = payload.end_at?.trim() ? payload.end_at : null;

      const url =
        mode === "edit" && editingId
          ? `${API_BASE}/anketler/${editingId}`
          : `${API_BASE}/anketler`;

      const method = mode === "edit" && editingId ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        notify(TT.savedOk, { type: "success" });
        if (mode !== "edit") {
          // create ise formu temizle
          setSurvey({
            baslik_tr: "",
            baslik_en: "",
            baslik_de: "",
            aciklama_tr: "",
            aciklama_en: "",
            aciklama_de: "",
            resim: "",
            aktif: true,
            taslak: false,
            login_required: true,
            one_per_user: true,
            start_at: "",
            end_at: "",
            max_text_length: 500,
            questions: [],
          });
          setVer((v) => v + 1); // olası eski preview'u kır
        }
      } else {
        notify(TT.savedErr, { type: "warning" });
      }
    } catch {
      notify(TT.savedErr, { type: "warning" });
    } finally {
      setSaving(false);
    }
  };

  // JSON sekmesi durumu
  const [jsonText, setJsonText] = React.useState("[]");
  const [jsonValid, setJsonValid] = React.useState(true);

  // survey.questions değiştiğinde JSON'u güncelle (senkron)
  React.useEffect(() => {
    try {
      setJsonText(JSON.stringify(survey.questions || [], null, 2));
      setJsonValid(true);
    } catch {
      // ignore
    }
  }, [survey.questions]);

  // JSON editörden survey.questions'a yaz (kaydırmalı)
  const onJsonChange = (value) => {
    setJsonText(value || "[]");
    try {
      const arr = JSON.parse(value || "[]");
      if (Array.isArray(arr)) {
        set({ questions: arr });
        setJsonValid(true);
      } else {
        setJsonValid(false);
      }
    } catch {
      setJsonValid(false);
    }
  };

  if (loading) return <div className="p-6">Yükleniyor…</div>;



return (
  <>
    <GlobalStyles
      styles={{
        "h1, h2, h3, h4, h5": {
          color: "#2563eb !important",
          fontWeight: 800,
        },
        label: {
          color: "#1e293b !important",
          fontWeight: 600,
        },
        "input, textarea, select": {
          borderColor: "#cbd5e1 !important",
          borderRadius: "6px",
        },
        "input:focus, textarea:focus, select:focus": {
          borderColor: "#2563eb !important",
          boxShadow: "0 0 0 1px #2563eb !important",
        },
      "input[type=checkbox]": {
  accentColor: "#f97316 !important", // turuncu
},
".cover-image-box": {
  border: "2px dashed #f97316 !important",
},
button: {
  backgroundColor: "#2563eb !important", // mavi
          color: "#ffffff !important",
          fontWeight: 700,
          borderRadius: "6px",
          padding: "8px 14px",
        },
        ".save-button, button[type=submit]": {
          backgroundColor: "#2563eb !important",
          color: "#fff !important",
          borderRadius: "8px",
          fontWeight: 800,
        },
        ".template-btn": {
          backgroundColor: "#2563eb !important",
          color: "#fff !important",
          fontWeight: 700,
        },
        ".cover-image-box": {
          border: "2px dashed #f59e0b !important",
          borderRadius: "8px",
          padding: "10px",
          background: "#fff7e6 !important",
        },
        ".MuiChip-root": {
          backgroundColor: "#2563eb !important",
          color: "#fff !important",
          fontWeight: 700,
        },
      }}
    />


        <form onSubmit={trySave} className="space-y-4">
          {/* Genel */}
<Section title={TT.general}>
            {/* Kapak görseli — EtkinliklerPage tarzı */}
            <div
              style={{
              display: "grid",
gridTemplateColumns: "1fr",
gap: 16,
                alignItems: "center",
              }}
            >
              <CoverImageRow
label={TT.image}
                value={survey.resim} // aynı isim
                onChange={(v) => set({ resim: v })} // aynı isim
                ver={ver}
                setVer={setVer}
              />
              <div style={{ display: "grid", gap: 10 }}>


<Toggle
  label={TT.active}
  checked={survey.aktif}
  onChange={(v) => set({ aktif: v })}
  TT={TT}
/>



            <Toggle
  label={TT.draft}
  checked={survey.taslak}
  onChange={(v) => set({ taslak: v })}
  TT={TT}
/>
              </div>
            </div>

            {/* Çok dilli başlık/açıklama */}
{sadeceDil.map((code) => (
              <div
                key={code}
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: 12,
                  background: "#fafafa",
                  marginTop: 8,
                }}
              >
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  {code.toUpperCase()}
                </div>
                <Row
label={TT.title}
                  value={survey[`baslik_${code}`] || ""}
                  onChange={(v) => set({ [`baslik_${code}`]: v })}
placeholder={TT.placeholderTitle}
                />
                <Area
label={TT.desc}
                  value={survey[`aciklama_${code}`] || ""}
                  onChange={(v) => set({ [`aciklama_${code}`]: v })}
placeholder={TT.placeholderDesc}
                />
              </div>
            ))}

            {/* Kurallar + Tarihler */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
gap: 16,
marginTop: 8,

              }}
            >
              <div className="space-y-2">


<Toggle
  label={TT.loginRequired}
  checked={survey.login_required}
  onChange={(v) => set({ login_required: v })}
  TT={TT}
/>



              <Toggle
  label={TT.onePerUser}
  checked={survey.one_per_user}
  onChange={(v) => set({ one_per_user: v })}
  TT={TT}
/>




              </div>
              <div className="space-y-2">
<div style={{ fontWeight: 700 }}>{TT.dates}</div>
                <DateTimeRow
label={TT.startAt}
                  value={survey.start_at || ""}
                  onChange={(v) => set({ start_at: v })}
                />


              <DateTimeRow
  label={TT.endAt}
  value={survey.end_at || ""}
  onChange={(v) => set({ end_at: v })}
/>

              </div>
            </div>

            <div style={{ maxWidth: 320, marginTop: 8 }}>
              <Row
label={TT.maxTextLen}
                value={String(survey.max_text_length ?? 500)}
                onChange={(v) =>
                  set({
                    max_text_length:
                      Number((v || "0").replace(/\D/g, "")) || 500,
                  })
                }
                placeholder="500"
              />
            </div>
          </Section>

          {/* SORULAR — Basit Oluşturucu */}
<Section title={TT.questions}>
            {/* Hızlı şablonlar */}
            <div>
              <div style={{ fontWeight: 700, marginBottom: 8 }}>
{TT.quickTemplates}
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button
                  type="button"
                  onClick={() => applyTemplate("yes-no-maybe")}
                  className="px-3 py-2 rounded text-white"
                  style={{ background: "#334155" }}
                >
{TT.tplYesNoMaybe}
                </button>
                <button
                  type="button"
                  onClick={() => applyTemplate("yes-no")}
                  className="px-3 py-2 rounded text-white"
                  style={{ background: "#475569" }}
                >
{TT.tplYesNo}
                </button>
                <button
                  type="button"
                  onClick={() => applyTemplate("rsvp-note")}
                  className="px-3 py-2 rounded text-white"
                  style={{ background: "#1e293b" }}
                >
{TT.tplRsvpNote}
                </button>
              </div>
            </div>

            {/* Soru listesi */}
            <div className="space-y-3" style={{ marginTop: 10 }}>
              {(survey.questions || []).map((q, idx) => (
                <QuestionEditor
                  key={q.id || idx}
                  q={q}
                  aktifDiller={aktifDiller}
TT={TT}
                  onChange={(updated) => {
                    const arr = [...(survey.questions || [])];
                    arr[idx] = updated;
                    set({ questions: arr });
                  }}
                  onRemove={() => {
                    const arr = [...(survey.questions || [])];
                    arr.splice(idx, 1);
                    set({ questions: arr });
                  }}
                />
              ))}
            </div>

            <button
              type="button"
              onClick={addQuestion}
              className="px-4 py-2 rounded text-white"
              style={{ backgroundColor: "#16a34a", marginTop: 6 }}
            >
{TT.addQuestion}
            </button>
          </Section>

          {/* İLERİ DÜZEY (JSON) */}
<Section title={TT.advanced}>
            {Editor ? (
              <Editor
                height="260px"
                defaultLanguage="json"
                value={jsonText}
                onChange={(val) => onJsonChange(val ?? "[]")}
                options={{ minimap: { enabled: false }, wordWrap: "on" }}
              />
            ) : (
              <textarea
                className="w-full border rounded px-3 py-2"
                rows={12}
                value={jsonText}
                onChange={(e) => onJsonChange(e.target.value)}
              />
            )}
            {!jsonValid && (
              <div style={{ color: "#ef4444", marginTop: 6, fontWeight: 700 }}>
{TT.jsonInvalid}
              </div>
            )}
          </Section>

          {/* ÖNİZLEME */}
<Section title={TT.preview}>
            <SurveyPreview
              survey={survey}
              aktifDiller={aktifDiller}
TT={TT}
            />
          </Section>

          {/* KAYDET */}
          <div className="pt-2">
            <button
              type="submit"
              disabled={saving || !jsonValid}
              className="px-6 py-2 rounded text-white disabled:opacity-60"
              style={{ backgroundColor: "#2563eb" }}
            >
{saving ? TT.saving : TT.save}
            </button>
          </div>
        </form>
    </>
  );
}

// ===================== MODERN KART GÖRÜNÜMLÜ LISTE =====================

const pickTitleByLang = (item) => {
  const lang = (localStorage.getItem("app_lang") || "tr")
    .slice(0, 2)
    .toLowerCase();

  return (
    item[`baslik_${lang}`] ||
    item.baslik_tr ||
    item.baslik_en ||
    item.baslik_de ||
    "—"
  );
};

const AnketActions = () => {
  const TT = useUiTexts();
  return (
    <TopToolbar>
      <CreateButton label={`+ ${TT.createTitle}`} />
    </TopToolbar>
  );
};



export const AnketList = (props) => {
  const TT = useUiTexts(); // dil desteği

  return (
  <List
  {...props}
  perPage={25}
  actions={<AnketActions />}
  empty={<EmptyAnketDesign />}   // 👈 SADECE BU
>
  <AnketCardList />
</List>
  );
};




/* ====== BOŞ LİSTE TASARIMI (TR / EN / DE Destekli) ====== */
/* === ⬇⬇⬇ İŞTE BURAYA YAPIŞTIRACAKSIN  ⬇⬇⬇ === */

const EmptyAnketDesign = () => {
  const TT = useUiTexts();

  const emptyTexts = {
    tr: {
      title: "Henüz Anket Yok",
      desc: "Buradan kolayca yeni bir anket oluşturabilirsiniz.",
      btn: "Yeni Anket Ekle",
    },
    en: {
      title: "No Surveys Yet",
      desc: "You can create a new survey here.",
      btn: "Add New Survey",
    },
    de: {
      title: "Noch Keine Umfrage",
      desc: "Hier können Sie eine neue Umfrage erstellen.",
      btn: "Neue Umfrage Hinzufügen",
    },
  };

  const lang = (localStorage.getItem("app_lang") || "tr").slice(0, 2);
  const L = emptyTexts[lang] || emptyTexts.tr;

  return (
    <div
      style={{
        padding: "40px",
        textAlign: "center",
        border: "2px dashed #cbd5e1",
        borderRadius: 12,
        marginTop: 20,
        background: "#f8fafc",
      }}
    >
      <div style={{ fontSize: 28, fontWeight: 800, color: "#1e293b" }}>
        🗳️ {L.title}
      </div>
      <div style={{ fontSize: 16, color: "#475569", marginTop: 8 }}>
        {L.desc}
      </div>

      <button
        onClick={() => (window.location.hash = "#/anketler/create")}
        style={{
          marginTop: 20,
          padding: "10px 20px",
          borderRadius: 8,
          background: "#2563eb",
          color: "white",
          fontWeight: 700,
          cursor: "pointer",
          border: "none",
        }}
      >
        + {L.btn}
      </button>
    </div>
  );
};





const AnketCardList = () => {
  const TT = useUiTexts();
  const { data, isLoading } = useListContext();

  if (isLoading) return <div className="p-6">Yükleniyor…</div>;




  return (
    <Box
      sx={{
        p: 3,
        display: "grid",
        gap: 2,
gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
        justifyContent: "center",
      }}
    >
 {data.map((item, index) => (
  <Paper
    key={item.id}
    elevation={3}
    onClick={() => (window.location.hash = `#/anketler/${item.id}`)}
    sx={{
      borderRadius: 3,
      cursor: "pointer",
      transition: "0.2s",
      border: "1px solid #e5e7eb",
      overflow: "hidden",
      "&:hover": {
        transform: "scale(1.02)",
        borderColor: "#6366f1",
      },
    }}
  >
    {/* ÜST BANNER */}
    <div
      style={{
        height: 80,
        background: (() => {
          const c = BANNER_COLORS[index % BANNER_COLORS.length];
          return `linear-gradient(90deg, ${c[0]} 0%, ${c[1]} 100%)`;
        })(),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        fontSize: 18,
        fontWeight: 800,
      }}
    >
      🗳️ {TT.pageTitle}
    </div>

    {/* BAŞLIK + AKTİF / TASLAK */}
    <Stack direction="row" justifyContent="space-between" mb={1} p={1.5}>
    <Typography variant="h6" sx={{ fontWeight: 800 }}>
  {pickTitleByLang(item)}
</Typography>


      {item.aktif ? (
        <Chip
          icon={<CheckIcon />}
          label={TT.active}
          size="small"
          sx={{ bgcolor: "#16a34a", color: "white", fontWeight: "bold" }}
        />
      ) : (
        <Chip
          icon={<CloseIcon />}
          label={TT.draft}
          size="small"
          sx={{ bgcolor: "#dc2626", color: "white", fontWeight: "bold" }}
        />
      )}
    </Stack>

    {/* TASLAK ETİKETİ */}
    {item.taslak && (
      <Chip
        label={TT.draft}
        size="small"
        sx={{
          bgcolor: "#f59e0b",
          color: "white",
          fontWeight: "bold",
          mb: 1,
          ml: 1.5,
        }}
      />
    )}

    {/* TARİHLER */}
    <Stack direction="row" spacing={1} alignItems="center" mt={1} px={1.5}>
      <CalendarMonthIcon sx={{ color: "#475569" }} />
      <Typography sx={{ fontSize: 14, color: "#334155" }}>
        <b>{TT.startAt}:</b> {item.start_at ? item.start_at.slice(0, 10) : "—"}
      </Typography>
    </Stack>

    <Stack direction="row" spacing={1} alignItems="center" mt={0.5} px={1.5}>
      <CalendarMonthIcon sx={{ color: "#475569" }} />
      <Typography sx={{ fontSize: 14, color: "#334155" }}>
        <b>{TT.endAt}:</b> {item.end_at ? item.end_at.slice(0, 10) : "—"}
      </Typography>
    </Stack>

    {/* KART NUMARASI */}
    <Box mt={2} px={1.5} sx={{ fontSize: 13, fontWeight: "bold", color: "#475569" }}>
      {TT.pageTitle} #{index + 1}
    </Box>

{/* --- İşlem Butonları (DÜZENLE + SİL) --- */}
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    marginTop: 12,
    padding: "0 12px 12px 12px",
  }}
>
  {/* Düzenle */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      window.location.hash = `#/anketler/${item.id}`;
    }}
    style={{
      background: "#2563eb",
      color: "white",
      padding: "6px 10px",
      borderRadius: 6,
      fontWeight: 700,
      cursor: "pointer",
      border: "none",
    }}
  >
    {TT.edit}
  </button>

  {/* Sil */}
  <button
    onClick={async (e) => {
      e.stopPropagation();
      if (!window.confirm(TT.delete + " ?")) return;

      const token = localStorage.getItem("token");
      await fetch(`${API_BASE}/anketler/${item.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      window.location.reload();
    }}
    style={{
      background: "#dc2626",
      color: "white",
      padding: "6px 10px",
      borderRadius: 6,
      fontWeight: 700,
      cursor: "pointer",
      border: "none",
    }}
  >
    {TT.delete}
  </button>
</div>

  </Paper>
))}
</Box>
);
};



/* =========================== RA Export’ları =========================== */
export function AnketlerPage(props) {
  return <AnketList {...props} />;
}

export function AnketCreate(props) {
  return <SharedAnketForm mode="create" {...props} />;
}

export function AnketEdit(props) {
  return <SharedAnketForm mode="edit" {...props} />;
}

export default AnketlerPage;
